const accountCodeMap = {
  china: "d85f2bdd.JPEG",
  vietnam: "71d60d32.JPEG",
  indonesia: "2685fc17.PNG",
  "united states": "",
  "united kingdom": "",
  malaysia: "51da4f62.PNG",
  philippines: "",
  thailand: "ff184dc0.PNG",
  "hong kong": "",
  taiwan: "",
  singapore: "51da4f62.PNG",
  default: "discord",
};

export default accountCodeMap;
